import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserFindTransaction = {
  userFindTransaction: { data: null, loading: false, error: null },
};

export const userFindTransaction = createAsyncThunk('user/userFindTransaction', async (transactionId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/transaction/${transactionId}`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserFindTransaction = {
  [userFindTransaction.pending]: (state) => {
    state.userFindTransaction.loading = true;
  },
  [userFindTransaction.fulfilled]: (state, action) => {
    state.userFindTransaction.loading = false;
    state.userFindTransaction.data = action.payload;
    state.userFindTransaction.error = null;
  },
  [userFindTransaction.rejected]: (state, action) => {
    state.userFindTransaction.loading = false;
    state.userFindTransaction.error = action.payload;
  },
};
